import ReactDOM from 'react-dom';
import { ReactElement } from 'react';

const root = document.getElementById('app-container');

export function renderReactApp(reactElem: ReactElement, ...args: any[]) {
  ReactDOM.render(reactElem, root, ...args);
}
